import React, {useState} from "react";
import {locale} from "../../../../../common/consts";
import {Plus as AddIcon} from "react-feather"
import styles from "../style.module.css"
import Dropzone from 'react-dropzone';
import {Button, CircularProgress, FormControl, TextField, Typography} from "../../../../../common/components/libs";
import {observer} from "mobx-react";
import {useStores} from "../../../../../hooks";
import {
    changeCheckboxEventHandlerDecorator,
    changeEventHandlerDecorator,
    toFloat,
    toPenny
} from "../../../../../common/libs";
import {MenuFormType} from "../../../store/menu/forms";
import {uploadFile} from "../../../../../services/files";
import {
    Box,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import {SnackbarType} from "../../../../../stores/common";
import {useHistory} from "react-router-dom";
import {trackAddPosition} from "../../../../utils/MetrikaService";
import {BadgeType, MediaItems, MediaType} from "../../../../../services/menu/models";
import ImageCropperForm, {ImageAspectRatio} from "../../../../../common/components/ImageCropperForm";
import {useTranslation} from "react-i18next";

export const defaultMediaItems: MediaItems = {
    preview: "",
    previewHighRes: "",
    regular: "",
    regularHighRes: "",
    source: "",
    sourceId: ""
};


const CreateMenuItemForm = () => {
    const { menuStore, generalStore } = useStores();
    const currencyId = generalStore.currency.id;
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const [currentFile, setCurrentFile] = useState<File | undefined>();
    const [photos, setPhotos] = useState([]);
    const [price, setPrice] = useState("");
    const [isRequestInProgress, setIsRequestInProgress] = useState(false);

    const [newBadgeChecked, setNewBadgeChecked] = useState <boolean> (false);
    const [spicyBadgeChecked, setSpicyBadgeChecked] = useState <boolean> (false);
    const [verySpicyBadgeChecked, setVerySpicyBadgeChecked] = useState <boolean> (false);
    const [vegetarianBadgeChecked, setVegetarianBadgeChecked] = useState <boolean> (false);
    const [hitBadgeChecked, setHitBadgeChecked] = useState <boolean> (false);

    const [weight, setWeight] = useState<string | null>(null);
    const [measurement, setMeasurement] = useState<string | null>(null);
    const [calories, setCalories] = useState<number | null>( null);
    const [carbohydrates, setCarbohydrates] = useState<number | null>( null);
    const [fats, setFats] = useState<number | null>( null);
    const [proteins, setProteins] = useState<number | null>( null);

    const [media, setMedia] = useState<MediaItems[]>([]);
    const [fileName, setFileName] = useState<string>("");
    const [isUploadInProgress, setIsUploadInProgress] = useState(false);
    const [isUploadPreviewInProgress, setIsUploadPreviewInProgress] = useState(false);
    const [isUploadRegularInProgress, setIsUploadRegularInProgress] = useState(false);
    const [isImagePreviewCropperVisible, setIsImagePreviewCropperVisible] = useState(false);
    const [isImageRegularCropperVisible, setIsImageRegularCropperVisible] = useState(false);
    const [sourceId, setSourceId] = useState("")
    const [mediaType, setMediaType] = useState<MediaType>(MediaType.source)
    const mediaLinks = defaultMediaItems;

    const {i18n, t} = useTranslation(["general", "menu"]);
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    const history = useHistory();

    if (!menuStore.currentMenu) return null;
    if (menuStore.currentMenu.menuCategories.length === 0) return null;
    if (menuStore.selectedCategory === undefined) return null;

    const forms = menuStore.forms;

    const closeForm = () => {
        forms.closeForm(MenuFormType.createMenuItem);
    };

    const checkSource = (str: string) => {
        if (str.includes(sourceId)) return true;
        else return false;
    }


    const handleSubmit = async () => {
        setIsRequestInProgress(true);
        const categoryId = menuStore.currentMenu.menuCategories[menuStore.selectedCategory].id;
        const res = await menuStore.createMenuItem({
            badges: {
                [BadgeType.new]: {
                    isEnabled: newBadgeChecked,
                    type: BadgeType.new
                },
                [BadgeType.spicy]: {
                    isEnabled: spicyBadgeChecked,
                    type: BadgeType.spicy
                },
                [BadgeType.vegetarian]: {
                    isEnabled: vegetarianBadgeChecked,
                    type: BadgeType.vegetarian
                },
                [BadgeType.verySpicy]: {
                    isEnabled: verySpicyBadgeChecked,
                    type: BadgeType.verySpicy
                },
                [BadgeType.hit]: {
                    isEnabled: hitBadgeChecked,
                    type: BadgeType.hit
                },
            },
            name: { [locale]: title },
            description: { [locale]: description },
            sortOrder: 0,
            isInStopList: false,
            menuCategoryId: categoryId,
            menuItemModifierSets: [],
            participatesInPromotions: true,
            photosUrls: photos,
            sellPrice: {
                price: toPenny(toFloat(price)),
                currencyId: currencyId
            },
            productId: null,
            inputProductAmountNetto: 0,
            outputProductAmountNetto: null,
            manufactureId: null,
            stopListSettings: null,
            workingSchedule: menuStore.itemWorkingSchedule,
            cookingTimeFromCategory: false,
            itemCookingTime: {
                fromTime: null,
                toTime: null
            },
            media: media,
            caloriesSettings: {
                calories: calories,
                carbohydrates: carbohydrates,
                fats: fats,
                proteins: proteins
            },
            weightSettings: {
                measurement: measurement,
                value: weight
            },
            arCodeLink: null,
            arCodeImage: null,
            supplierLogoUrl: null,
        });
        if (res.err) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedCreateMenu"),
                type: SnackbarType.error
            })
        } else {
            setIsRequestInProgress(false);
            generalStore.showSnackbar({
                title: t("menu:menuEditor.positionCreated"),
                type: SnackbarType.success
            });
            history.push(`/menus/regular/${menuStore.currentMenu.id}/${categoryId}/${res.menuItemId}`);
            closeForm();
            trackAddPosition();

        }
    };

    const uploadImage = async (file: File) => {
        setIsUploadInProgress(true);

        try {
            setPhotos([]);
            const res = await uploadFile(file, MediaType.all);
            const { sourceDownloadUrl, sourceIdentifier, previewDownloadUrl, regularDownloadUrl } = res;
            setPhotos([sourceDownloadUrl]);
            mediaLinks.source = sourceDownloadUrl;
            mediaLinks.preview = previewDownloadUrl;
            mediaLinks.previewHighRes = previewDownloadUrl;
            mediaLinks.regular = regularDownloadUrl;
            mediaLinks.regularHighRes = regularDownloadUrl;
            mediaLinks.sourceId = sourceIdentifier;
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedLoadIMG"),
                type: SnackbarType.error
            })
        } finally {
            media[0] = mediaLinks;
            setMedia(media);
            setIsUploadInProgress(false);
        }
        return;
    };

    const customizeImage = async (file: File) => {
        try {
            if (!media[0]?.source) return;
            setFileName('');
            const res = await uploadFile(file, mediaType, sourceId);
            const { downloadUrl, highResDownloadUrl } = res;
            if (mediaType === MediaType.preview) {
                mediaLinks.preview = downloadUrl;
                mediaLinks.previewHighRes = highResDownloadUrl;
                setFileName(`${sourceId + '_preview.jpeg'}`)
            }
            if (mediaType === MediaType.regular) {
                mediaLinks.regular = downloadUrl;
                mediaLinks.regularHighRes = highResDownloadUrl;
                setFileName(`${sourceId + '_regular.jpeg'}`)
            }

            media[0] = mediaLinks;
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedLoadIMG"),
                type: SnackbarType.error
            })
        } finally {
            if (mediaType === MediaType.preview) setIsUploadPreviewInProgress(false);
            if (mediaType === MediaType.regular) setIsUploadRegularInProgress(false);
        }
        return;
    };


    const onDrop = async (files: File[]) => {
        setCurrentFile(files[0]);
        await uploadImage(files[0]);
    };

    const form = menuStore.forms.forms[MenuFormType.createMenuItem];


    return (
        <>
            <Dialog
                open={form.open}
                onClose={closeForm}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={"md"}
                fullScreen={!isSm}
            >
                <DialogTitle id="form-dialog-title">
                    {t("menu:menuEditor.addPosition")}
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", flexDirection: isSm? "row": "column"}}>
                        <div className={styles.images}>
                            {media.length == 0 && !isUploadInProgress && (
                                <Dropzone onDrop={onDrop} key="cmif_1s">
                                    {({ getRootProps, getInputProps }) => (
                                        <div {...getRootProps({ className: styles.dropzone })}
                                             style={{ height: "140px", width: "210px" }}>
                                            <input {...getInputProps()} />
                                            <AddIcon size={30}/>
                                            <span>{t("general:load")}</span>
                                        </div>
                                    )}
                                </Dropzone>
                            )}
                            {isUploadInProgress && (
                                <div
                                    key="cmif_3"
                                    style={{
                                        height: "140px",
                                        width: "210px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <CircularProgress
                                        m={2}
                                        color="secondary"
                                    />
                                </div>
                            )}
                            {media.length > 0 && !isUploadInProgress && (
                                <Box>
                                    <div className={styles.menuItemEditor} key="cmif_4">
                                        <img src={media[0].source}
                                             alt=""
                                             key={media[0].source}
                                             style={{height: 140, width: 210, objectFit: 'cover'}}/>
                                    </div>,
                                    <Dropzone onDrop={onDrop} key="cmif_5">
                                        {({getRootProps, getInputProps}) => (
                                            <>
                                                <div {...getRootProps()}
                                                     style={{textAlign: 'center'}}>
                                                    <input {...getInputProps()}  />
                                                    <Button color={"primary"}>{t("general:replace")}</Button>
                                                </div>
                                            </>
                                        )}
                                    </Dropzone>
                                </Box>
                            )}
                        </div>
                        <div style={{ flexGrow: 1 }}>
                            <TextField
                                onChange={changeEventHandlerDecorator(setTitle)}
                                label={t("general:name")}
                                variant="outlined"
                                fullWidth
                                my={0}
                                value={title}
                            />
                            <FormControl fullWidth my={3} variant="outlined">
                                <TextField
                                    onChange={changeEventHandlerDecorator(setDescription)}
                                    label={t("general:description")}
                                    multiline={true}
                                    rows={4}
                                    rowsMax={4}
                                    variant="outlined"
                                    value={description}
                                />
                            </FormControl>
                            <FormControl fullWidth my={3} variant="outlined">
                                <TextField
                                    onChange={changeEventHandlerDecorator(setPrice)}
                                    label={t("menu:menuEditor.priceSale")}
                                    variant="outlined"
                                    value={price}
                                />
                            </FormControl>
                            <Typography variant={"h6"} mt={5} mb={2}>
                                {t("menu:menuEditor.specialPositionMark")}
                            </Typography>
                            <FormControl>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={newBadgeChecked}
                                                onChange={changeCheckboxEventHandlerDecorator(setNewBadgeChecked)}
                                                value={newBadgeChecked}
                                            />
                                        }
                                        label={t("menu:badgeType.New")}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={spicyBadgeChecked}
                                                onChange={changeCheckboxEventHandlerDecorator(setSpicyBadgeChecked)}
                                                value={spicyBadgeChecked}
                                            />
                                        }
                                        label={t("menu:badgeType.Spicy")}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={verySpicyBadgeChecked}
                                                onChange={changeCheckboxEventHandlerDecorator(setVerySpicyBadgeChecked)}
                                                value={verySpicyBadgeChecked}
                                            />
                                        }
                                        label={t("menu:badgeType.VerySpicy")}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={vegetarianBadgeChecked}
                                                onChange={changeCheckboxEventHandlerDecorator(setVegetarianBadgeChecked)}
                                                value={vegetarianBadgeChecked}
                                            />
                                        }
                                        label={t("menu:badgeType.Vegetarian")}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={hitBadgeChecked}
                                                onChange={changeCheckboxEventHandlerDecorator(setHitBadgeChecked)}
                                                value={hitBadgeChecked}
                                            />
                                        }
                                        label={t("menu:badgeType.Hit")}
                                    />
                                </FormGroup>
                            </FormControl>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions style={{ paddingRight: 20, paddingBottom: 10 }}>
                    <Button
                        color="secondary"
                        mr={3}
                        onClick={() => {
                            closeForm()
                        }}
                    >
                        {t("general:cancel")}
                    </Button>
                    { isRequestInProgress ?
                        <Button
                            color="primary"
                            variant="contained"
                            disabled
                        >
                            <CircularProgress
                            size={25}
                            color="secondary"
                        />
                        </Button>  :

                        <Button
                            color="primary"
                            variant="contained"
                            onClick={handleSubmit}
                        >
                            {t("general:next")}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
            <ImageCropperForm
                open={isImagePreviewCropperVisible}
                close={() => {
                    setIsImagePreviewCropperVisible(false);
                    setIsUploadPreviewInProgress(false)
                }}
                image={currentFile}
                uploadImage={customizeImage}
                aspectRation={ImageAspectRatio.rectangle_3_2}
                name={fileName}
            />
            <ImageCropperForm
                open={isImageRegularCropperVisible}
                close={() => {
                    setIsImageRegularCropperVisible(false);
                    setIsUploadPreviewInProgress(false)
                }}
                image={currentFile}
                uploadImage={customizeImage}
                aspectRation={ImageAspectRatio.rectangle_3_2}
                name={fileName}
            />
        </>
    );
};

export default observer(CreateMenuItemForm);
